module.exports = __webpack_public_path__ + "static/img/img_1.850d90f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_1.jpg
// module id = xjjZ
// module chunks = 0